import styled from 'styled-components'


export const AwscViewStyle = styled.div`
   position: relative;
   height: 34px;
   .nc_iconfont {
    height: 34px !important;

   }
`